/** @jsx jsx */
import { Box, jsx } from 'theme-ui'

import './layout.css'
import GlobalFontStyle from '../fonts/typography'
import { node } from 'prop-types'
import LogoHeader from './header/LogoHeader'
import EmptyFooter from './footer/EmptyFooter'

const UnauthenticatedLayout = ({ children }) => {
  return (
    <div>
      <GlobalFontStyle />
      <LogoHeader />
      <Box
        as="main"
        sx={{
          margin: '0 auto',
          backgroundColor: 'background',
        }}
      >
        {children}
      </Box>
      <Box
        as="footer"
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <EmptyFooter />
      </Box>
    </div>
  )
}

UnauthenticatedLayout.propTypes = {
  children: node.isRequired,
}

export default UnauthenticatedLayout
